<form class="providerForm" [formGroup]="providerForm" (ngSubmit)="providerDetailsSubmit()">
    <div class="row main-home py-0">
        <div class="col-md-12">
            <p role="heading" aria-level="1">Please enter any information you have regarding the {{title}}</p>
        </div>
    </div>
    <div class="row main-home" *ngIf="isNameRequired || isRequiredIdLabelVisible">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <span class="col-form-label" style="font-size:14px;" *ngIf="isNameRequired">
                Organization Name or First & Last Name Required
            </span>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <span class="col-form-label" style="font-size:14px;" *ngIf="isRequiredIdLabelVisible">
                {{requiredIdFormat}}
            </span>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
        </div>
    </div>
    <div class="row main-home" role="form">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
            <form [formGroup]="providerFormPart1">
                <app-json-form *ngIf="isformloaded" [controlsData]="providerFormData1.controls" [formData]="providerFormPart1"
                (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
            </form>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
            <form [formGroup]="providerFormPart2">
                <app-json-form *ngIf="isformloaded" [controlsData]="providerFormData2.controls" [formData]="providerFormPart2"
                (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
            </form>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
            <form [formGroup]="providerFormPart3">
                <app-json-form *ngIf="isformloaded" [controlsData]="providerFormData3.controls" [formData]="providerFormPart3"
                    (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
            </form>
        </div>
        
    </div>
</form>